import React, {ChangeEvent, useEffect, useState} from 'react';
import {IHandlers, IProps} from './types';
import style from './style.module.scss';
import {BookingTags} from './BookingTags';
import {BookingLinks} from './BookingLinks';
import AlertDialog from 'app/common/AlertDialog';
import {BookingOptions} from './BookingOptions';
import {SummaryTextField} from './SummaryTextField';
import BeverageHistoryPage from 'app/common/BeverageHistoryPage';
import BeverageHistoryService from 'app/services/beverageHistory/BeverageHistory.service';
import UtilsService from "internal-services/utils/utils.service";
import {IPurchasedItemInfo} from "app/app.types";
import ChipAvatar from "app/common/ChipAvatar";
import {Checkbox, createStyles, FormControlLabel, Theme} from '@material-ui/core';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import {makeStyles} from '@material-ui/core/styles';
import {renderIf} from "app/services/reactUtils.service";
import { BookingStatusNames, bookingStatusType, BookingType } from 'shared-types/index';

const NS = 'BookingOverview';

function getMaterialStyles() {
  return makeStyles((theme: Theme) => {

    return createStyles({
      checkboxFC: {
        margin: '0 10px 0 0',
        color: 'rgba(0,0,0,0.87)'
      },
      checkbox: {
        color: theme.palette.primary.main,
        padding: '6px 9px 6px 0'
      }
    });
  });
}

export default function BookingOverview({
  bookingInfo, paymentInfo, bookingNotesInfo, bookingLinks, linesOccupiedByBookingOptions,
  linesOccupiedByUpsellOptions, isManager, customerId, venueId, currency, handleEmailSmsNotification, isSmsEnabled,
  isStandbyOrWaitlist, isStatusNameInList
}: IProps & IHandlers) {

  const useStyles = getMaterialStyles();
  const classes = useStyles();

  const [beverageList, setBeverageList] = useState<IPurchasedItemInfo[]>([]);

  /** Show/Hide the beverage history page */
  const [shouldShowBeverageHistoryPage, toggleBeverageHistoryPage] = useState<boolean>(false);
  useEffect(() => {
    // Fetch beverage list on mount
    (async () => {
      const beverages = venueId && customerId ? await BeverageHistoryService.getCustomerBeverageInfo(venueId, customerId): [];
      setBeverageList(beverages);
    })();
  }, [venueId, customerId]);

  // const hasBeverageHistory = beverageList && beverageList.length > 0;
  const hasBeverageHistory = false; // Hiding wine button again as part of https://nowbookit.atlassian.net/browse/NBI-4608

  return (
    <div className={style.root}>
      {
        hasBeverageHistory &&
        <div className={style.beverageSummary} onClick={() => toggleBeverageHistoryPage(true)}>
          <ChipAvatar/>
        </div>
      }
      <BookingTags {...bookingInfo.tags} />
      <SummaryTextField labelText="Booking Notes" value={UtilsService.htmlDecode(bookingNotesInfo.bookingNotes, true)}/>
      <SummaryTextField labelText="Customer Notes" value={bookingNotesInfo.customerNotes}/>
      <SummaryTextField labelText="Manager Notes"
                        value={(isManager && bookingNotesInfo.managerNotes ? bookingNotesInfo.managerNotes : "")}/>
      <BookingLinks {...bookingLinks}/>
      <BookingOptions
        bookingOptionList={bookingInfo.selectedOptions}
        linesOccupiedByBookingOptions={linesOccupiedByBookingOptions}
        isUpsell={false}
      />
      <BookingOptions
        bookingOptionList={bookingInfo.selectedOptions}
        linesOccupiedByBookingOptions={linesOccupiedByUpsellOptions}
        isUpsell={true}
      />
      <SummaryTextField labelText="Type" value={paymentInfo.paymentType}/>
      <SummaryTextField labelText="Price" value={paymentInfo.price}/>
      {renderIf(!isStandbyOrWaitlist && customerId && (isStatusNameInList(bookingInfo.status.name, [bookingStatusType.confirmed, bookingStatusType.unconfirmed, bookingStatusType.pendingPayment])) , () => (
        <div>
          <p className={style.summaryLabel}>Communication</p>
          <FormControlLabel
            className={classes.checkboxFC}
            control={
              <Checkbox
                className={classes.checkbox}
                color="default"
                size="medium"
                icon={<CheckBoxOutlineBlankIcon fontSize="large"/>}
                checkedIcon={<CheckBoxIcon fontSize="large"/>}
                name="checkedI"
                defaultChecked={bookingInfo.disableEmailSmsNotification}
                onChange={(e: ChangeEvent<HTMLInputElement>) => handleEmailSmsNotification(e.target.checked)}
              />
            }
            label={`${isSmsEnabled ? 'Do not send emails or SMS' : 'Do not send emails'}`}
          />
        </div>
      ))}
      {
        shouldShowBeverageHistoryPage &&
        <AlertDialog
          closeButtonText="Close"
          dialogHeaderText="Beverages"
          showAlertDialog={shouldShowBeverageHistoryPage}
          onAlertDialogClose={() => toggleBeverageHistoryPage(false)}>
          <BeverageHistoryPage beverageList={beverageList} currency={currency} />
        </AlertDialog>
      }
    </div>
  )
}
